import { loader } from 'graphql.macro'

export default async function updateOnlineScheduleCustomizations ({ dataLoaders, variables }) {
  const schema = loader('./updateOnlineScheduleCustomizations.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  return response.updateOnlineScheduleCustomizations
}
